import React from 'react';
export function Hero() {
  return <section className="relative w-full px-6 py-12 md:py-20 lg:py-24" data-id="element-55">
      <div className="mx-auto max-w-3xl" data-id="element-56">
        {/* Headline */}
        <h1 className="mb-8 text-center text-4xl font-bold leading-tight text-[#2D2420] md:text-5xl lg:text-6xl" data-id="element-57">
          <span className="italic text-[#C4704B]" data-id="element-58">Si te engañó</span> y aun así
          te sientes culpable… esto es para ti.
        </h1>

        {/* Image */}
        <div className="my-10 overflow-hidden rounded-2xl shadow-xl ring-1 ring-[#E8DDD4]" data-id="element-59">
          <img src="https://cdn.magicpatterns.com/uploads/j3V9LE6QFKLJGK5RX96ppV/3.png" alt="Mujer sentada en la mesa de la cocina con café y teléfono, mirando hacia abajo pensativa" className="h-auto w-full object-cover" data-id="element-60" />
        </div>

        {/* Opening Lead */}
        <div className="mx-auto max-w-xl space-y-6 text-lg text-[#2D2420] md:text-xl" data-id="element-61">
          <p className="font-semibold" data-id="element-62">Te engañó.</p>

          <p data-id="element-63">Y lo peor no es solo lo que hizo.</p>

          <p data-id="element-64">
            Lo peor es esto:{' '}
            <span className="bg-[#FFF3E8] px-1 font-medium text-[#C4704B]" data-id="element-65">
              te volteó la culpa… y tú te la creíste.
            </span>
          </p>

          <div className="border-l-4 border-[#E8DDD4] pl-6 italic text-[#8B7D75]" data-id="element-66">
            <p className="mb-2" data-id="element-67">Te escuchas pidiendo perdón por llorar.</p>
            <p className="mb-2" data-id="element-68">Pidiendo perdón por preguntar.</p>
            <p data-id="element-69">Pidiendo perdón por no “superarlo” rápido.</p>
          </div>

          <p data-id="element-70">Y en algún momento te dices lo que más duele:</p>

          <p className="text-center font-serif text-2xl italic text-[#2D2420]" data-id="element-71">
            “Tal vez fue mi culpa.”
          </p>

          <p className="font-bold" data-id="element-72">No.</p>

          <p data-id="element-73">
            Lo que tienes no es “locura”. Es shock de traición + niebla mental +
            culpa como mecanismo de control.
          </p>

          <p className="text-[#C4704B]" data-id="element-74">
            Y se corta con estructura. No con fuerza de voluntad.
          </p>
        </div>
      </div>
    </section>;
}